import React, { useState, memo } from 'react';
import { HandshakeIcon } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
const inputClass = 'w-full h-12 px-4 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors';
const labelClass = 'block text-sm font-semibold text-[#333] mb-1.5';
const allianceTypes = [{
  icon: '🏢',
  title: 'Empresa',
  subtitle: 'Responsabilidad social corporativa',
  value: 'empresa'
}, {
  icon: '💚',
  title: 'Fundación',
  subtitle: 'Colaboración filantrópica',
  value: 'fundacion'
}, {
  icon: '🩺',
  title: 'Profesional de salud',
  subtitle: 'Red de especialistas',
  value: 'profesional_salud'
}, {
  icon: '🏛️',
  title: 'Entidad gubernamental',
  subtitle: 'Programas de impacto social',
  value: 'entidad_gubernamental'
}, {
  icon: '🎓',
  title: 'Institución educativa',
  subtitle: 'Investigación y formación',
  value: 'institucion_educativa'
}, {
  icon: '🌟',
  title: 'Marca comprometida',
  subtitle: 'Alianzas estratégicas',
  value: 'marca_comprometida'
}];
const aporteOptions = ['Financiamiento o donaciones', 'Servicios profesionales', 'Recursos educativos', 'Voluntariado', 'Difusión y comunicación', 'Infraestructura o espacio físico', 'Otro'];
export function QuieroSerAliado() {
  const [tipoAlianza, setTipoAlianza] = useState('');
  useDocumentMeta({
    title: 'Ser Aliado | Pancita Feliz Foundation',
    description: 'Únete como aliado de Pancita Feliz Foundation y ayuda a transformar vidas de familias venezolanas.',
    path: '/quiero-ser-aliado'
  });
  return <main className="w-full" data-id="element-322" data-mp="2900micite6hm">
      {/* Hero */}
      <section className="text-center" style={{
      background: 'linear-gradient(135deg, #f0f7e6 0%, #e8f5d0 100%)',
      padding: '60px 20px 40px'
    }} data-id="element-323" data-mp="2908v3s7wmpn0">
        <HandshakeIcon style={{
        width: '64px',
        height: '64px',
        color: '#7DC920',
        background: 'white',
        borderRadius: '50%',
        padding: '16px',
        boxShadow: '0 4px 16px rgba(125,201,32,0.2)',
        display: 'block',
        margin: '0 auto 24px auto'
      }} data-id="element-324" data-mp="2izhqmpif4cbh" />
        <h1 className="font-bold text-[#1a1a1a] mb-4" style={{
        fontSize: '42px'
      }} data-id="element-325" data-mp="34q9cxaea0vst">
          Quiero ser Aliado
        </h1>
        <p className="mx-auto" style={{
        fontSize: '18px',
        color: '#555',
        maxWidth: '600px'
      }} data-id="element-326" data-mp="3dqfk6ejdszjj">
          Únete a nuestra red de aliados y juntos transformemos el futuro del
          neurodesarrollo familiar
        </p>
      </section>

      {/* Form */}
      <section className="px-4 py-12 bg-white" data-id="element-327" data-mp="1ocssl9hlzigf">
        <div className="mx-auto bg-white" style={{
        maxWidth: '680px',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        padding: '48px',
        marginBottom: '60px'
      }} data-id="element-328" data-mp="1oe3v75zbik5y">
          <form action="https://formspree.io/f/mpqgrdzr" method="POST" data-id="element-329" data-mp="5nq1et6j9tdg">
            <input type="hidden" name="_replyto" value="info@pancitafelizfoundation.org" data-id="element-330" data-mp="1o7gvyimjkb5" />
            <input type="hidden" name="_subject" value="🤝 Nueva Solicitud de Alianza - Pancita Feliz Foundation" data-id="element-331" data-mp="3srw4jee2bbcc" />

            <h2 className="text-[22px] font-bold text-[#1a1a1a] mb-8" data-id="element-332" data-mp="pdicl1l4aoif">
              Información del Aliado
            </h2>

            {/* Personal / Organizational */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4" data-id="element-333" data-mp="fdre6otfrpd2">
              Información Personal / Organizacional
            </p>

            <div className="mb-5" data-id="element-334" data-mp="3051l8kszei0g">
              <label className={labelClass} data-id="element-335" data-mp="304s3fki3bh5u">
                Nombre completo / Razón social
              </label>
              <input type="text" name="nombre_organizacion" required placeholder="Tu nombre o nombre de tu organización" className={inputClass} data-id="element-336" data-mp="rvk2kqlemjen" />
            </div>

            <div className="mb-5" data-id="element-337" data-mp="nuibix1n5dnr">
              <label className={labelClass} data-id="element-338" data-mp="nvjnr4ue8672">Correo electrónico</label>
              <input type="email" name="email" required placeholder="correo@empresa.com" className={inputClass} data-id="element-339" data-mp="1bjt4vtgnw5rv" />
            </div>

            <div className="mb-5" data-id="element-340" data-mp="11l3ns2wlapco">
              <label className={labelClass} data-id="element-341" data-mp="11o99d860f93n">Teléfono / WhatsApp</label>
              <input type="tel" name="telefono" required placeholder="+1 (000) 000-0000" className={inputClass} data-id="element-342" data-mp="16jybnj9ez43n" />
            </div>

            <div className="mb-5" data-id="element-343" data-mp="3r9e1aawwcmrp">
              <label className={labelClass} data-id="element-344" data-mp="3jrg5f97n1a6y">Sitio web (opcional)</label>
              <input type="url" name="sitio_web" placeholder="https://www.tusitio.com" className={inputClass} data-id="element-345" data-mp="3jtsmlk5kngiy" />
            </div>

            <div className="mb-5" data-id="element-346" data-mp="3ntjiu3dvaouv">
              <label className={labelClass} data-id="element-347" data-mp="3num8y93d8n9q">País</label>
              <select name="pais" required className={inputClass} defaultValue="" data-id="element-348" data-mp="3nrqckp7626ne">
                <option value="" disabled data-id="element-349" data-mp="2w3y9r2l95ryp">
                  Selecciona tu país
                </option>
                <option data-id="element-350" data-mp="39vcrl63fbn46">Venezuela</option>
                <option data-id="element-351" data-mp="353bkrzp0yolj">Colombia</option>
                <option data-id="element-352" data-mp="3529x8vqto9mx">México</option>
                <option data-id="element-353" data-mp="3518lep1zfj45">Estados Unidos</option>
                <option data-id="element-354" data-mp="2hcfksfaf0n37">España</option>
                <option data-id="element-355" data-mp="2hbe8y8lkrwkf">Otro</option>
              </select>
            </div>

            {/* Alliance type */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-356" data-mp="2ccjrpb39ag2f">
              Tipo de Alianza
            </p>

            <div className="mb-6" data-id="element-357" data-mp="l9kkwro00m0z">
              <label className={labelClass} data-id="element-358" data-mp="l8hx4slz2zpa">¿Cómo deseas ser aliado?</label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2" data-id="element-359" data-mp="q242s0tpy3bl">
                {allianceTypes.map(type => {
                const selected = tipoAlianza === type.value;
                return <label key={type.value} className="cursor-pointer transition-colors" style={{
                  border: `2px solid ${selected ? '#7DC920' : '#e0e0e0'}`,
                  borderRadius: '12px',
                  padding: '16px',
                  background: selected ? '#f0f7e6' : '#ffffff'
                }} data-id="element-360" data-mp="3tjcfk69laczg">
                      <input type="radio" name="tipo_alianza" value={type.value} checked={selected} onChange={() => setTipoAlianza(type.value)} className="sr-only" required data-id="element-361" data-mp="1mr1vzeltlt6n" />
                      <div style={{
                    fontSize: '24px'
                  }} data-id="element-362" data-mp="2yey0n6um0cqa">
                        {type.icon}
                      </div>
                      <div className="text-[#1a1a1a] mt-1" style={{
                    fontSize: '14px',
                    fontWeight: 600
                  }} data-id="element-363" data-mp="2jjrsoebye3ub">
                        {type.title}
                      </div>
                      <div style={{
                    fontSize: '12px',
                    color: '#666'
                  }} data-id="element-364" data-mp="drd107x99cd6">
                        {type.subtitle}
                      </div>
                    </label>;
              })}
              </div>
            </div>

            {/* Details */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-365" data-mp="3428nysxflpoj">
              Detalles
            </p>

            <div className="mb-6" data-id="element-366" data-mp="38zr16viher2c">
              <label className={labelClass} data-id="element-367" data-mp="38yz7xrccx5f8">
                ¿Qué puedes aportar como aliado?
              </label>
              <div className="grid sm:grid-cols-2 gap-3 mt-2" data-id="element-368" data-mp="2z2w5ekdlf4rr">
                {aporteOptions.map(option => <label key={option} className="flex items-center gap-3 cursor-pointer text-[15px] text-[#333]" data-id="element-369" data-mp="2l3mnng9qo2lo">
                    <input type="checkbox" name="aporte" value={option} className="w-5 h-5 accent-primary" data-id="element-370" data-mp="2q40wh0j5zgkr" />
                    {option}
                  </label>)}
              </div>
            </div>

            <div className="mb-8" data-id="element-371" data-mp="23uamtr9rey0e">
              <label className={labelClass} data-id="element-372" data-mp="23vc0m3i5tylt">
                Cuéntanos sobre tu organización y cómo quieres colaborar
              </label>
              <textarea name="mensaje" required rows={5} placeholder="Describe tu organización, tu misión y cómo crees que podemos trabajar juntos..." className="w-full px-4 py-3 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors resize-none" data-id="element-373" data-mp="2dryj4ln0kdko" />
            </div>

            <button type="submit" className="w-full text-white font-bold rounded-xl transition-colors hover:bg-[#6ab518]" style={{
            height: '52px',
            fontSize: '16px',
            background: '#7DC920'
          }} data-id="element-374" data-mp="2wiprbjv9lxxh">
              Enviar Solicitud de Alianza
            </button>

            <p className="text-center mt-4" style={{
            fontSize: '12px',
            color: '#888'
          }} data-id="element-375" data-mp="1w8iquyjz03mo">
              🔒 Tu información es confidencial y será tratada con total
              privacidad
            </p>
          </form>
        </div>
      </section>
    </main>;
}